import {Event as Event_V3} from '@wix/ambassador-events-v3-event/types'
import {addQueryParams} from '@wix/panda-js-utils'
import {getEventId, getSlug} from '@wix/wix-events-commons-statics'
import {CommonState, Multilingual} from '../types/state'

export const getEventUrl = (pageUrl: string = '', event: wix.events.Event | Event_V3, multilingual: Multilingual) => {
  const url = `${pageUrl}/${getSlug(event)}`

  if (multilingual.isEnabled) {
    const lang = multilingual.currentLanguage
    return addQueryParams(url, {lang})
  }

  return url
}

export const getEventDateInformation = (state: CommonState, id: string) => state.dates.events[id]

export const isMultiDay = (state: CommonState, event: wix.events.Event | Event_V3) => {
  const events = state.dates.events
  const eventId = getEventId(event)
  const multiDay = events[eventId].multiDayInfo?.duration > 1

  return multiDay
}
